import React from 'react';
import { dateWordShort } from 'helper/helper';
import { Warning } from 'assets/icons';
import MobileListCard from './MobileListCard';
import Tooltip from 'components/tooltips/Tooltips';

const sectorConfig = {
  sale: { label: 'Vente', className: 'bg-gray-50 text-gray-600 ring-gray-500/10' },
  food: { label: 'Restauration', className: 'bg-green-50 text-green-600 ring-green-500/10' },
  logistic: { label: 'Logistique', className: 'bg-yellow-50 text-yellow-600 ring-yellow-500/10' },
  largeDistribution: { label: 'Grande distribution', className: 'bg-blue-50 text-blue-600 ring-blue-500/10' },
  administration: { label: 'Administration', className: 'bg-purple-50 text-purple-600 ring-purple-500/10' },
  other: { label: 'Autre', className: 'bg-red-50 text-red-600 ring-red-500/10' },
};

const QualificationMobileCard = ({ item, onEdit, isSelected }) => {
  const sector = sectorConfig[item.type] || sectorConfig.other;

  return (
    <MobileListCard
      title={item.name}
      onClick={() => onEdit(item._id)}
      isSelected={isSelected}
      warning={
        !item.idBestt ? (
          <Tooltip text="La mission n'a pas été référencée sur BeSTT" placement="top">
            <Warning wh={17} color="#EF4444" />
          </Tooltip>
        ) : null
      }
      topRightBadge={
        <span className={`inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset ${sector.className}`}>
          {sector.label}
        </span>
      }
      date={item.createdAt ? dateWordShort(item.createdAt) : 'N/A'}
      dateLabel="Créé le"
      statusBadge={
        item.isActive === false ? (
          <span className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-600 ring-red-500/10">
            Désactivé
          </span>
        ) : null
      }
    />
  );
};

export default QualificationMobileCard;

